import {assert} from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import type {Media} from '../types';

export const mapMediaDto = (dto: Schemas.MediaDto): Media => {
  const extension = assert.soft(
    dto.fileExtension,
    'mapMediaDto: fileExtension expected',
    dto,
  )
    ? dto.fileExtension
    : 'PDF';

  return {
    id: assert(dto.mediaId, 'mapMediaDto: mediaId expected', dto),
    version: dto.version ?? 1,
    type: assert(dto.mediaType, 'mapMediaDto: mediaType expected', dto),
    subType: assert(
      dto.mediaSubType,
      'mapMediaDto: mediaSubType expected',
      dto,
    ),
    extension,
    fileNr: parseInt(dto.filenumber ?? '0', 10),
    ...dto,
  };
};
